module.exports = __webpack_public_path__ + "img/atlas-arrow.b477196d.svg";